import PropTypes from "prop-types";
import React from "react";
import { useTheme } from "@/components/ThemeProvider";

import "./QuerySourceTypeIcon.less";

export function QuerySourceTypeIcon(props) {
  const { isDarkMode } = useTheme();

  return (
    <img 
      src={`static/images/db-logos/${props.type}.png`} 
      width="20" 
      alt={props.alt}
      className={`query-source-type-icon ${isDarkMode ? 'dark-mode' : ''}`}
    />
  );
}

QuerySourceTypeIcon.propTypes = {
  type: PropTypes.string,
  alt: PropTypes.string,
};
